
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
    .state('workplan.doctoralFormation', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/doctoralFormation',
      views: {
        '': {
          template: require('./doctoralFormation/list/index.html')
        },
        'principal@': {
          template: require('./doctoralFormation/list/doctoralList.html'),
          controller: 'DoctoralListCtrl',
          controllerAs: 'doctoralListVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Formación doctoral',
        order: 3,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.teachingDevelopment',
            order: 1
          },
          {
            name: 'workplan.learningAndPracticeCommunities',
            order: 2
          },
          {
            name: 'workplan.history',
            displayName: 'Ver resumen',
            order: 4
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.consolidationCP,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createDoctorate', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/createDoctorate/:workplanTeacherActivityId',
      template: require('./doctoralFormation/create/createDoctorate.html'),
      controller: 'CreateDoctorateCtrl',
      controllerAs: 'createDoctorateVm',
      data: {
        displayName: 'Formación doctoral',
        order: 3,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.teachingDevelopment',
            order: 1
          },
          {
            name: 'workplan.learningAndPracticeCommunities',
            order: 2
          },
          {
            name: 'workplan.history',
            displayName: 'Ver resumen',
            order: 4
          }
        ]
      },
      params: {
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.teachingDevelopment', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/teachingDevelopment',
      views: {
        '': {
          template: require('./teachingDevelopment/list/index.html')
        },
        'principal@': {
          template: require('./teachingDevelopment/list/teachingDevList.html'),
          controller: 'TeachingDevListCtrl',
          controllerAs: 'teachingDevListVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Desarrollo profesoral',
        order: 1,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.doctoralFormation',
            order: 3
          },
          {
            name: 'workplan.learningAndPracticeCommunities',
            order: 2
          },
          {
            name: 'workplan.history',
            displayName: 'Ver resumen',
            order: 4
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.consolidationCP,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.teachingJobsReview', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/teachingDevelopment/reviewTeachingDevelopment',
      template: require('./teachingDevelopment/listTeacherJobsView/reviewTeacherDevelopment.html'),
      controller: 'ReviewTeacherDevelopmentCtrl',
      controllerAs: 'reviewTVM',
      data: {
        displayName: 'Desarrollo profesional',
        order: 1,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.doctoralFormation',
            order: 3
          },
          {
            name: 'workplan.createLearningCommunities',
            order: 2
          }
        ]
      },
      params: {
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createCourse', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/createCourse/:workplanTeacherActivityId',
      template: require('./teachingDevelopment/createCourse/createCourse.html'),
      controller: 'CreateCourseCtrl',
      controllerAs: 'createCourseVm',
      data: {
        displayName: 'Desarrollo profesoral',
        order: 1,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.doctoralFormation',
            order: 3
          },
          {
            name: 'workplan.learningAndPracticeCommunities',
            order: 2
          },
          {
            name: 'workplan.history',
            displayName: 'Ver resumen',
            order: 4
          }
        ]
      },
      params: {
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.learningAndPracticeCommunities', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/learningAndPracticeCommunities',
      views: {
        '': {
          template: require('./learningAndPracticeCommunities/list/index.html')
        },
        'principal@': {
          template: require('./learningAndPracticeCommunities/list/learningCommunityList.html'),
          controller: 'LearningCommunityListCtrl',
          controllerAs: 'learningCommunityListVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Comunidades de aprendizaje y de práctica',
        order: 2,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.doctoralFormation',
            order: 3
          },
          {
            name: 'workplan.teachingDevelopment',
            order: 1
          },
          {
            name: 'workplan.history',
            displayName: 'Ver resumen',
            order: 4
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.consolidationCP,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createLearningCommunities', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/createLearningCommunities/activityTypeId/:activityTypeId/workplanTeacherActivityId/:workplanTeacherActivityId',
      template: require('./learningAndPracticeCommunities/create/createLearningComunity.html'),
      controller: 'CreateLearningComunityCtrl',
      controllerAs: 'createLearningComunityVM',
      data: {
        displayName: 'Comunidades de aprendizaje y de práctica',
        order: 2,
        title: 'Consolidación Cuerpo Profesoral',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.doctoralFormation',
            order: 3
          },
          {
            name: 'workplan.teachingDevelopment',
            order: 1
          },
          {
            name: 'workplan.history',
            displayName: 'Ver resumen',
            order: 4
          }
        ]
      },
      params: {
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.consolidationCP', {
      moduleId: GlobalConfig.modules.consolidation,
      abstract: false,
      url: '/consolidationCP/teachingDevelopment',
      redirectTo: 'workplan.teachingDevelopment',
      data: {
        displayName: 'Consolidación Cuerpo Profesoral',
        title: 'Consolidación Cuerpo Profesoral'
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.consolidationCP,
        stage: GlobalConfig.workplanStages.planning
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/consolidation.route.js